// 列表组件
<template>
  <ul>
    <li v-for="(item, index) in dataList" :key="item.user_id" @click.stop.prevent="goHomePage(item.id, item.is_follow, index, 'jump')">
      <img class="avatar" :src="item.image" />
      <div class="main">
        <div class="infos">
          <div class="user">
            <span class="title_ap">{{ item.title }}</span>
            <img
              class="medal"
              v-for="(md, i) in getMedals(item)"
              :key="i"
              :src="md.image"
            />
          </div>
          <div class="intro2">{{ item.intro }}</div>
          <div class="follow_num">粉丝数：{{ item.follow_num }}</div>
        </div>
        <div
          class="flbtn"
          :class="{ flok: item.is_follow === 'yes' }"
          v-html="item.is_follow === 'yes' ? '已关注' : '<span></span>关注'"
          @click.stop.prevent="call_change_focus(item,index)"
        ></div>
      </div>
    </li>
  </ul>
</template>

<script>
import api from "@/api/tops";
import * as utils from "@/utils/index";
import { Toast } from 'vant';
export default {
  name: "userList",
  props: ["dataList", "type", "topIsShow","over1200"],
  data() {
    return {
      baseURL: null
    }
  },
  created() {
    let baseURL = 'https://appdev.aigupiao.com';
    if (process.env.NODE_PM === 'prod') {
        baseURL = 'https://app.aigupiao.com';
    } else if (process.env.NODE_PM === 'dev') {
        baseURL = 'https://appdev.aigupiao.com';
    } else if (process.env.NODE_PM === 'beta') {
        baseURL = 'https://appbeta.aigupiao.com';
    }
    this.baseURL=  baseURL;
    console.info(this.baseURL,'type',this.type)
  },
  methods: {
    // 老师 和 用户的 ID,是否关注,索引,类型
    goHomePage(id, is_follow, index, type){
      if(!this.topIsShow && this.baseURL && type != 'jump') {
        if(this.$route.query && !this.$route.query.u_id) {
          // alert("当前未登录！")
          utils.getAppIgpGoToLogin();
          return
        }
        // https://app.aigupiao.com/api/live.php?
        let url = `https://app.aigupiao.com/api/live.php`;
        let params = {
          act: is_follow == 'yes'?"unfollow": "follow",
          u_id: this.$route.query.u_id,
          id
        }

        api['getGaoShouHot'](url, params).then((res) => {
          console.log("res --", res);
          if (res.rslt === "succ") {
            this.$set(this.dataList[index], 'is_follow', is_follow == 'yes'? 'no': 'yes');
            // Toast.show({
            //     icon: 'success',
            //     content: is_follow == 'yes'? '关注成功': '取消关注成功',
            // })
            Toast.success(is_follow == 'no'? '关注成功': '取消关注成功');
          } else {
            console.log("error");
          }
        });
      } else {
        if(this.type === 'daRen'){
          location.href = `?funToApp&jump_u_id=${id}`
        }else{
          location.href = `?funToApp&jump_l_id=${id}`
        }
      }
    },
    call_change_focus(item,index){
      if(this.over1200){
        //调用app方法
        this.$srH5CallNativeMethodApp('call_change_focus',{
          u_id: (item.u_id||item.user_id||0), //关注的人用户id
          focus : item.is_follow == 'yes' ? 'no' : 'yes',//关注操作：关注、取消关注
          l_id : ((item.l_id > 0)||(item.id != (item.u_id||item.user_id))) ? (item.l_id||item.id) : 0,//关注的人老师id
          kind : ((item.l_id > 0)||(item.id != (item.u_id||item.user_id))) ? 'teacher' : 'user',
        })
        //console.log(item,'item')
      }
      else{
        this.goHomePage(item.id, item.is_follow, index);
      }
    },
    // 后端接口勋章字段适配
    getMedals(item){
      return item.user_medals_tail || item.medals
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

ul {
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: rem(24px);
    border-bottom: $a-dl-eb-e8 solid 0.25px;
	box-sizing: border-box;
	
    .avatar {
      width: rem(124px);
      height: rem(124px);
      border-radius: 50%;
    }
    .main {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
	  overflow: hidden;
	  
      .infos {
        padding-left: rem(20px);
        font-size: rem(26px);
		flex: 1;
		overflow: hidden;
        line-height: 1.7em;
		
		
        .user {
          display: flex;
          align-items: center;
          font-size: rem(30px);
          color: #222222;
          .title_ap {
            font-weight: bold;
			color: $a-dl-f3-3;
          }
          .medal {
            width: rem(30px);
            height: rem(30px);
            margin-left: rem(8px);
          }
        }
        .intro2 {
          color: $a-dl-b7-63;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .follow_num {
          color: #939393;
        }
      }
      .flbtn {
        width: rem(126px);
        height: rem(64px);
        background: $a-dl-121212-fff;
        border-radius: rem(8px);
        border: 1px solid #fe484a;
        flex: none;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fe484a;
        font-size: rem(28px);
        ::v-deep span {
          background: url("../../assets/img/tops/jia.png") no-repeat;
          background-size: cover;
          display: inline-block;
          width: rem(20px);
          height: rem(20px);
          margin-right: rem(7px);
        }
        &.flok {
          color: #939393;
          border-color: #afafaf;
        }
      }
    }
  }
}
</style>
